import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../state";
import ReactLoading from "react-loading";
import ManageUrls from "../endpoints/manage_urls";
import config from '../env-config.json';
import { history } from "../history";

function AgentDetails() {

  const { state } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agent, setAgent] = useState(null);
  const manageUrls = new ManageUrls();
  const params = useParams();

  useEffect(() => {
    fetchAgentDetails();
  }, [params.id]);

  const getLocation = (agent) => {
    const location = state.cashPickupLocations.find(location => location.value === agent.relationships.cash_pickup_location.data.id);
    return location ? location.key : "Not specified";
  }

  const fetchAgentDetails = () => {
    setLoading(true);
    fetch(manageUrls.getApiUrl() + 'cash_pickup_agents/' + params.id + "/", {
      mode: 'cors',
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'Authorization': 'Bearer ' + state.accessToken,
        'App-Id': config.app_id,
      },
    })
    .then(res => {
      if (res.status >= 400) {
        setHasError(true);
        setErrorMessage("Failed to fetch agent details.");
        history.goBack();
        setLoading(false);
        setAgent(null);
        return Promise.reject("Failed to fetch agent details.");
      }

      return res;
    })
    .then(res => res.json())
    .then(res => {
      setHasError(false);
      setAgent(res.data);
      console.log("agents details:", agent, res.data);
      setLoading(false);
    })
  }


  const renderErrorMessage = () => {
    return (
      <div className="">
        <div
          className="alert alert-warning alert-dismissible fade show"
          role="alert"
        >
          <strong>Error: </strong> {errorMessage}
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    );
  };

  const renderFetching = () => {
    if (loading) {
      return (
        <div className="col-6 offset-sm-3 text-center">
          <p>Loading agent details. Please wait...</p>
          <ReactLoading
            className="searching--spinner--100"
            type={"bars"}
            color={"#154989"}
          />
        </div>
      );
    }
  };

  const renderDetails = ({
    heading,
    firstLabel,
    firstValue,
    secondLabel,
    secondValue,
  }) => {
    return (
      <div className="col-6 ">
        <div className="card" style={{ marginTop: "40px" }}>
          <div className="card-body">
            <h5 className="card-title">{heading}</h5>
            <hr />
            <div className="row">
              <div className="col-6">
                <p className="card-text">
                  <b>{firstLabel}: </b>
                </p>
              </div>
              <div className="col-6">
                <p className="card-text">
                  {firstValue}
                </p>
              </div>
              <div className="col-12" style={{ marginTop: "15px" }} />
              <div className="col-6">
                <p className="card-text">
                  <b>{secondLabel}: </b>
                </p>
              </div>
              <div className="col-6">
                <p className="card-text">{secondValue}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (hasError) {
    return renderErrorMessage();
  } else if (loading || !agent) {
    return (
      <div className="our-causes pt-0">
        <div className="container">
          <div className="row">
            <div className="col-12 ">
              <div className="cause-wrap">
                <div className="cause-content-wrap">
                  <header className="entry-header d-flex flex-wrap align-items-center" />
                  <div className="entry-content">{renderFetching()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    console.log("agent render", agent);
    
    return (
      <div className="our-causes pt-0">
        <div className="container">
          <div className="row">
            {renderDetails({
              heading: "Agent Details",
              firstLabel: "Full Name",
              firstValue: `${agent.attributes.first_name} ${agent.attributes.last_name}`,
              secondLabel: "Location",
              secondValue: getLocation(agent),
            })}
            {renderDetails({
              heading: "Contacts",
              firstLabel: "Email",
              firstValue: agent.attributes.email,
              secondLabel: "Mobile",
              secondValue: `+${agent.attributes.mobile[0]}${agent.attributes.mobile[1]}`,
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default AgentDetails;